<template>
  <figure class="alert">
    <img
      src="../../../assets/images/alert.png"
      alt="alert icon"
      width="20px"
      height="17px"
    />
    <figcaption class="alert-text" v-if="alertText === 'not-found'">
      {{ alertJsonText.notFound[lang] }}
    </figcaption>
    <figcaption class="alert-text" v-if="alertText === 'cache-error'">
      {{ alertJsonText.cacheError[lang] }}
    </figcaption>
    <figcaption class="alert-text" v-if="alertText === 'invalid-token'">
      {{ alertJsonText.invalidToken[lang] }}
    </figcaption>
  </figure>
</template>

<script>
import Alert from "../../../assets/constants/confirmation/alert/alert";
export default {
  props: {
    lang: {
      type: String,
    },
    alertText: {
      type: String,
    },
  },
  computed: {
    alertJsonText: function () {
      return Alert;
    },
  },
  name: "Alert",
};
</script>

<style scoped>
.alert {
  margin: 45px 0 0 0;
  padding: 15px;
  border: solid 1px #d6124b;
  color: #d6124b;
  text-align: center;
  .alert-text {
    margin: 10px 0 0 0;
    line-height: 1.3;
    font-size: 16px;
    white-space: pre-line;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/oauth/Alert.vue